import { makeAutoObservable } from "mobx";
import { RSet } from "../../collections";
import { Tristate } from "../../core";
export class PreorderSettingsAvailability {
    constructor(params) {
        this.fulfillmentTimeScope = params.fulfillmentTimeScope;
        this.preorderSettings = params.preorderSettings;
        makeAutoObservable(this);
    }
    get unavailabilityReasons() {
        if (this.isAvailable.isDefinitelyTrue) {
            return RSet.empty();
        }
        const isInThePast = this.preorderSettings.isInThePast;
        if (!this.preorderSettings.isSameDayOnly && isInThePast) {
            return RSet.fromIterable(["Preorder", "OutdatedPreorderSettings"]);
        }
        return RSet.singleton("Preorder");
    }
    get reasons() {
        const { fulfillmentTime } = this.fulfillmentTimeScope;
        if (fulfillmentTime === null) {
            return ["DateNotSelected"];
        }
        if (!this.preorderSettings.canOrderAt(fulfillmentTime)) {
            return ["FulfillmentTimeNotInRange"];
        }
        return [];
    }
    get isAvailable() {
        const { fulfillmentTime } = this.fulfillmentTimeScope;
        if (this.preorderSettings.isInThePast) {
            return Tristate.False;
        }
        // TODO: return False if intersection of the preorderSettings and restaurant ordering hours (with holidays) is empty
        if (fulfillmentTime === null) {
            // FIXME Tristate.Maybe should be there, but such change breaks multiple e2e tests
            return Tristate.True;
        }
        if (this.preorderSettings.canOrderAt(fulfillmentTime)) {
            return Tristate.True;
        }
        return Tristate.False;
    }
    accept(availabilityVisitor) {
        availabilityVisitor.visitPreorder(this);
    }
}
